import React from 'react';
import { Image } from 'semantic-ui-react';
import { string, func } from 'prop-types';

const OptionItem = ({ onClickItem, icon, content }) => (
  <div onClick={onClickItem} className="item">
    <div className="icon">
      <Image src={icon} alt={content} />
    </div>
    <div className="content">
      <span>{content}</span>
    </div>
  </div>
);

OptionItem.propTypes = {
  onClickItem: func.isRequired,
  content: string.isRequired,
  icon: string.isRequired,
};

export default OptionItem;
